export default __webpack_public_path__ + "static/media/WebIcon.020f8d0c.svg";